/**
 * Runtime configuration
 * ---------------------
 * Reads the Lambda Function URLs that Amplify writes into
 * `amplify_outputs.json` after a successful sandbox/pipeline deploy.
 *
 * Local dev (no sandbox yet)? The Vite proxy in vite.config.js falls back to
 * localhost:3001 so the same `/fred-proxy` and `/market-proxy` paths work.
 */

let _config = null;

export async function loadConfig() {
  if (_config) return _config;
  try {
    const res = await fetch('/amplify_outputs.json');
    if (res.ok) {
      const outputs = await res.json();
      _config = {
        fredProxyUrl:    outputs?.custom?.fredProxyUrl    ?? '/fred-proxy',
        marketProxyUrl:  outputs?.custom?.marketProxyUrl  ?? '/market-proxy',
        onchainProxyUrl: outputs?.custom?.onchainProxyUrl ?? '/onchain-proxy',
      };
      return _config;
    }
  } catch (e) {
    console.warn('[config] amplify_outputs.json missing — falling back to /api proxy paths');
  }
  // Local dev fallback — assumes vite.config.js proxy is wired up
  _config = {
    fredProxyUrl:    '/fred-proxy',
    marketProxyUrl:  '/market-proxy',
    onchainProxyUrl: '/onchain-proxy',
  };
  return _config;
}

export function getConfig() {
  if (!_config) {
    throw new Error('Config not loaded — call loadConfig() during app bootstrap');
  }
  return _config;
}
